import React, {useState, useEffect} from 'react';
import firebase from 'utils/firebase';
import axios from 'axios';

import {Tooltip} from 'components/Tooltip';
import {Loader} from 'components/Loader';
import {EmailIcon, InstagramIcon, TelegramIcon, RedditIcon, TwitterIcon, FacebookIcon, InfoIcon} from 'icons';

import './style.scss';

const VerifyEmail = () => (
  <div className="verify-email">
    <EmailIcon />
    Please confirm your email address
  </div>
);

const AccountPage = ({userEmail}) => {
  const [loading, setLoading] = useState(true);
  const [userStats, setUserStats] = useState(false);
  const {emailVerified} = firebase.auth().currentUser;

  useEffect(() => {
    async function setStats() {
      try {
        const userToken = await firebase.auth().currentUser.getIdToken();
        const accountStats = await axios.get('/v3/account/stats', {
          headers: {token: userToken},
        });
        setUserStats(accountStats.data);
        setLoading(false);
      } catch (error) {
        console.error(error);
      }
    }
    setStats();
  }, []);

  if (loading) {
    return <Loader />;
  }

  return (
    <div className="account-page">
      {!emailVerified && <VerifyEmail />}
      <div className="box account-stats">
        <div className="account-info-field">
          <div className="account-info-title">Email</div>
          <div className="account-info-value">{userEmail}</div>
        </div>
        <div className="account-info-field">
          <div className="account-info-title">Active strategies</div>
          <div className="account-info-value">{userStats.activeStrategiesQty}</div>
        </div>
        <div className="account-info-field">
          <div className="account-info-title">Settled picks</div>
          <div className="account-info-value">{userStats.placedBetsQty}</div>
        </div>
        <div className="account-info-field">
          <div className="account-info-title">
            <div>Profit</div>
            <Tooltip
              text="Profit/Loss is calculated by betting 100 virtual points on each favorite pick"
              className="tooltip-profit"
            >
              <div className="info-icon">
                <InfoIcon />
              </div>
            </Tooltip>
          </div>
          <div className="account-info-value">{userStats.balance.toFixed(2)}</div>
        </div>
      </div>
      <div className="box social">
        <div className="social-title">
          <div className="join">join</div>
          <div className="fs-community">Fireswan community</div>
        </div>
        <div className="social-links">
          <a href="http://instagram.com/fireswan.app" target="_blank" rel="noopener noreferrer">
            <InstagramIcon />
          </a>
          <a href="https://t.me/fireswan" target="_blank" rel="noopener noreferrer">
            <TelegramIcon />
          </a>
          <a href="https://www.reddit.com/r/fireswan/" target="_blank" rel="noopener noreferrer">
            <RedditIcon />
          </a>
          <a href="https://twitter.com/fireswan_app" target="_blank" rel="noopener noreferrer">
            <TwitterIcon />
          </a>
          <a href="https://www.facebook.com/fireswanstrategies" target="_blank" rel="noopener noreferrer">
            <FacebookIcon />
          </a>
        </div>
      </div>
    </div>
  );
};

export default AccountPage;
